import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, of, take } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import * as fromSettingsStore from '../../../stores/settings';
import { HelmsdeepService } from '../../services';
import { ApiErrorHandlerService } from '../../services/api-error-handler/api-error-handler.service';
import { REAR_PATHS } from '../../utils/constants';

@Component({
  selector: 'frodo-handed-off-reason',
  templateUrl: './handed-off-reason.component.html',
  styleUrls: ['./handed-off-reason.component.scss'],
})
export class HandedOffReasonComponent implements OnInit, OnDestroy {
  scheduleId: string;
  clientCode: string;
  flow: string;
  viewType: string;
  reasons: Record<string, string> = {};
  isLoading = false;
  noSort = (): number => 0;

  private sessionTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    private translateService: TranslateService,
    private helmsdeepService: HelmsdeepService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.scheduleId = this.activatedRoute.snapshot.paramMap.get('scheduleId');
    this.clientCode = this.activatedRoute.snapshot.paramMap.get('clientCode');
    this.flow = this.activatedRoute.snapshot.paramMap.get('flow');
    this.viewType = this.activatedRoute.snapshot.paramMap.get('viewType');

    this.loadReasons();
    this.startTimeout();
  }

  loadReasons() {
    this.isLoading = true;

    this.translateService.get('common.handedOff.reasons').subscribe((reasons) => {
      this.reasons = reasons;
    });
  }

  startTimeout() {
    this.isLoading = true;
    this.store
      .select(fromSettingsStore.selectSettingFrodoTimeouts)
      .pipe(
        take(1),
        map((timeouts) => timeouts?.associateTimeout)
      )
      .subscribe((timeout) => {
        this.isLoading = false;
        this.sessionTimeout = setTimeout(() => {
          this.onConfirm('TimeOut');
        }, timeout);
      });
  }

  onConfirm(reason: string) {
    this.isLoading = true;

    this.helmsdeepService
      .orderHandOff(this.scheduleId, [reason])
      .pipe(
        catchError((error) => {
          this.isLoading = false;
          this.apiErrorHandlerService.handleApiError(error, '');

          return of(undefined);
        })
      )
      .subscribe(() => {
        this.isLoading = false;
        this.router.navigate([`/${this.viewType}/${REAR_PATHS.DELIVERY_LIST}`]);
      });
  }

  ngOnDestroy(): void {
    this.sessionTimeout && clearTimeout(this.sessionTimeout);
  }
}
